import React from 'react';
import { bool, string, func } from 'prop-types';
import ClassNames from 'classnames';
import BaseComponent from '../.internal/BaseComponent';

import './SelectOption.scss';

export default class SelectOption extends BaseComponent {
  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('click', this.handleOptionClick, false);
    }
  }

  handleOptionClick = () => {
    const { disabled, onClick, value } = this.props;

    if (!disabled) {
      onClick(value);
    }
  };

  render() {
    const { children, className, disabled, prefix, selected } = this.props;
    const handleOptionClick = !disabled ? this.handleOptionClick : undefined;
    const componentClassNames = ClassNames(
      'select-option',
      className,
      disabled && 'disabled',
      selected && 'selected'
    );

    return (
      <li className={componentClassNames}>
        <button
          type="button"
          className="select-option__button"
          onClick={handleOptionClick}
        >
          {typeof prefix !== 'undefined' && (
            <div className="select-option__prefix-container">{prefix}</div>
          )}
          <div className="select-option__content">{children}</div>
        </button>
      </li>
    );
  }
}

SelectOption.propTypes = {
  children: string,
  className: string,
  disabled: bool,
  onClick: func,
  prefix: string,
  selected: bool,
  value: string
};

SelectOption.defaultProps = {
  children: '',
  className: undefined,
  disabled: false,
  onClick: undefined,
  prefix: undefined,
  selected: false,
  value: ''
};
